import TextButton from '../components/TextButton';
import clsx from "clsx";

export default function AlertWindow({ display, msg, links, object=null }) {

    return (
        <div className={clsx(display?"":"hidden","popup-bg")} id="alert-window">
            <div className="popup-window bg-white flex flex-col p-5 max-w-96 gap-4">
                <img className="h-20 object-contain" alt="logo" src="/iconslimsvet/logo.png">
                </img>
                {object}
                <div
                    className="text-center"
                    style={{ whiteSpace: "pre-line" }}
                    dangerouslySetInnerHTML={{ __html: msg }}
                />
                {links.map((link)=><Alink key={link.txt} href={link.href} txt={link.txt}/>)}
            </div>
        </div>
    )
}
const Alink = ({href,txt}) => {

    if (href !== undefined) {
        if (typeof href === "function") {
            return <TextButton text={txt} onClick={href} />
        } else if(typeof href === "string"){
            return <TextButton text={txt} onClick={()=>window.location.href = href} />
        }
    }

}